import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { ComponentProps, useState, ReactElement } from 'react';
import { SalesSummary } from './Sales/SalesSummary';
import { VisitSummary } from './Visit/VisitSummary';

export const viewDefinitions = {
  sales: {
    renderComponent: (props: ComponentProps<typeof SalesSummary>) => (
      <SalesSummary {...props} />
    ),
  },
  visit: {
    renderComponent: (props: ComponentProps<typeof VisitSummary>) => (
      <VisitSummary {...props} />
    ),
  },
};

type SummaryView = { label: string; Component: ReactElement };

type SummaryBodyProps = {
  views: SummaryView[];
  defaultView: SummaryView;
};

export const SummaryBody = (props: SummaryBodyProps) => {
  const { views, defaultView } = props;
  const [currentView, setCurrentView] = useState<string>(defaultView.label);

  return (
    <>
      {views.length > 1 ? (
        <ToggleButtonGroup
          exclusive
          value={currentView}
          onChange={(_e, value: string) => value && setCurrentView(value)}
        >
          {views.map(view => (
            <ToggleButton value={view.label} key={view.label}>
              {view.label}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      ) : null}

      {views.map(view => (
        <Box
          key={view.label}
          width="100%"
          sx={{
            display: currentView === view.label ? 'inherit' : 'none',
          }}
        >
          {view.Component}
        </Box>
      ))}
    </>
  );
};
